<div class="max-w-[1600px] mx-auto px-6 mt-6">
  <header class="bg-gradient-primary text-white shadow-sm rounded-2xl overflow-hidden" role="banner">
    <div class="flex items-center justify-between px-8 py-3">
      <div>
        <h1 class="text-[20px] font-bold tracking-tight leading-tight">{{ title() }}</h1>
        @if (subtitle()) {
        <p class="text-[14px] text-white/70 mt-1 font-medium">{{ subtitle() }}</p>
        }
      </div>
      <ng-content />
    </div>
  </header>
</div>
